// Portfolio holdings: the routes and the sidebar rows of `wealth.portfolio.holdings` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.portfolio.holdings',
    routes: [
        { frontend: 'desk', path: 'portfolio', lazy: () => import('@/pages/desk/portfolio/page') },
    ],
    nav: [
        {
            frontend: 'desk',
            key: 'portfolio',
            label: 'Portfolio',
            href: '/desk/portfolio',
            icon: 'PieChart',
            group: 'overview',
            order: 120,
        },
    ],
});
